import { render, staticRenderFns } from "./VendorListModal.vue?vue&type=template&id=3558b349"
import script from "./VendorListModal.vue?vue&type=script&lang=js"
export * from "./VendorListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports